import React from 'react';

import { STATIC_ROOT } from '../../constants';

export const Logo = () => (
    <img src={`${STATIC_ROOT}/logo.png`} alt="logo" width="150" height="44" />
);



// WEBPACK FOOTER //
// ./src/components/icons/Logo.js